import { render, staticRenderFns } from "./AromaReportList.vue?vue&type=template&id=36275612&scoped=true"
import script from "./AromaReportList.vue?vue&type=script&lang=js"
export * from "./AromaReportList.vue?vue&type=script&lang=js"
import style0 from "./AromaReportList.vue?vue&type=style&index=0&id=36275612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36275612",
  null
  
)

export default component.exports